/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommHeroBannerData } from './ecomm-hero-banner.data';
import { IEcommHeroBannerProps } from './ecomm-hero-banner.props.autogenerated';

export interface IEcommHeroBannerViewProps extends IEcommHeroBannerProps<IEcommHeroBannerData> {
    title: React.ReactNode;
    description: React.ReactNode;
}

/**
 *
 * EcommHeroBanner component
 * @extends {React.PureComponent<IEcommHeroBannerProps<IEcommHeroBannerData>>}
 */
class EcommHeroBanner extends React.PureComponent<IEcommHeroBannerProps<IEcommHeroBannerData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const title = config.description && (
            <MsDyn365.RichTextComponent
                text={config.title}
                editProps={{
                    onEdit: this._handleDescriptionChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const description =
            config.description === '' || config.description === undefined ? null : (
                <MsDyn365.RichTextComponent
                    text={config.description}
                    editProps={{
                        onEdit: this._handleDescriptionChange,
                        requestContext: this.props.context.request
                    }}
                />
            );

        const EcommHeroBannerViewProps = {
            ...this.props,
            title: title,
            description: description
        };

        return this.props.renderView(EcommHeroBannerViewProps);
    }

    private _handleDescriptionChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommHeroBanner;
